'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresGiftCards]');

var WinresGiftCardsController = function () {
    function WinresGiftCardsController($scope, $q, discountService, cancelService) {
        _classCallCheck(this, WinresGiftCardsController);

        this.$scope = $scope;
        this.$q = $q;
        this.discountService = discountService;
        this.cancelService = cancelService;
    }

    _createClass(WinresGiftCardsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.data = this.context.getContext();

            this.$scope.$watchCollection(function () {
                return _this.data.GiftCards;
            }, function () {
                return _this.updateGiftCardAmounts();
            }, true);

            this.$scope.$watch(function () {
                return _this.context.amountToPay;
            }, function () {
                return _this.updateGiftCardAmounts();
            });

            this.$scope.$watch(function () {
                return !!(_this.promise && _this.promise.$$state && _this.promise.$$state.status === 0);
            }, function (pending) {
                if (_this.onStateChange) {
                    _this.onStateChange({ pending: pending });
                }
            });

            this.checkGiftCardVisibility();

            this.recheckGiftCards();
        }
    }, {
        key: 'checkGiftCardVisibility',
        value: function checkGiftCardVisibility() {
            var _this2 = this;

            this.discountService.getGiftCardSettings().then(function (settings) {
                // Show gift card field in shopping cart.
                _this2.$scope.showGiftCard = settings.InUse;

                // The text field starting value.
                // Note that enabled gift cards are included in the booking session,
                // so nothing needs to be loaded here unlike in the discount code case above.
                _this2.giftCardNumber = '';
            });
        }
    }, {
        key: 'updateGiftCardAmounts',
        value: function updateGiftCardAmounts() {
            if (!this.data.GiftCards) {
                this.data.GiftCards = [];
            }

            var lines = _.concat(this.data.Products, this.data.DiscountProducts || []);
            var total = _.sumBy(lines, function (line) {
                return line.TotalPrice || 0;
            }) + (this.data.HiddenPrice || 0);

            var leftToPay = total;
            if (this.context.amountToPay > 0) {
                leftToPay = this.context.amountToPay;
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.data.GiftCards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var gc = _step.value;

                    gc.Amount = Math.min(gc.Balance, leftToPay);
                    leftToPay -= gc.Amount;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.leftToPay = leftToPay;
        }
    }, {
        key: 'recheckGiftCards',
        value: function recheckGiftCards() {
            var _this3 = this;

            var oldGiftCards = this.data.GiftCards || [];
            this.data.GiftCards = [];
            if (this.promise) {
                this.cancelService.cancel(this.promise);
            }
            this.promise = undefined;
            var promise = this.$q.resolve(true);
            oldGiftCards.forEach(function (gc) {
                // Do these one by one so we don't mess things up.
                promise = promise.then(function () {
                    _this3.promise = _this3.useGiftCardInternal(gc.Number);
                    return _this3.promise;
                }).catch(function () {}); // Keep going even if one fails.
            });
            promise.then(function () {
                _this3.promise = undefined;
                _this3.updateGiftCardAmounts();
            });
        }
    }, {
        key: 'removeGiftCard',
        value: function removeGiftCard(giftCardNumber) {
            if (this.loadingGiftCard) return; // Should not happen since button gets disabled
            this.promise = undefined; // Clear old message.
            if (!this.data.GiftCards) {
                this.data.GiftCards = [];
            }
            this.data.GiftCards = this.data.GiftCards.filter(function (gc) {
                return gc.Number !== giftCardNumber;
            });
            this.updateGiftCardAmounts();
            if (this.onStateChange) {
                this.onStateChange({ pending: false });
            }
        }
    }, {
        key: 'useGiftCard',
        value: function useGiftCard() {
            var _this4 = this;

            if (this.loadingGiftCard) return; // Should not happen since button gets disabled
            if (this.promise) {
                // console.log(giftCardNumber, 'Canceling existing request for', this.promise.giftCardNumber);
                this.cancelService.cancel(this.promise);
            }
            var promise = this.useGiftCardInternal(this.giftCardNumber);
            this.promise = promise.then(function (success) {
                _this4.giftCardNumber = '';
                _this4.updateGiftCardAmounts();
            });
        }
    }, {
        key: 'useGiftCardInternal',
        value: function useGiftCardInternal(giftCardNumber) {
            var _this5 = this;

            giftCardNumber = _.trim(giftCardNumber || '');

            // console.log(giftCardNumber, 'Using gift card.');

            if (!this.data.GiftCards) {
                this.data.GiftCards = [];
            }

            if (this.data.GiftCards.some(function (gc) {
                return gc.Number === giftCardNumber;
            })) {
                return this.$q.reject('gift_cards.already_added');
            }

            this.loadingGiftCard = true;

            var request = this.discountService.checkGiftCard(giftCardNumber);

            var promise = request.then(function (result) {
                if (result == null) {
                    // Canceled.
                    // console.log(giftCardNumber, 'CheckGiftCard request was canceled.');
                    return _this5.$q.reject(''); // Return value should not matter in this case.
                }

                if (result.Status === 'Valid') {
                    var balance = result.Balance;

                    if (balance > 0) {
                        _this5.data.GiftCards.push({
                            Method: result.Method,
                            Number: giftCardNumber,
                            Balance: balance,
                            Amount: 0
                        });
                        return true;
                    } else {
                        return _this5.$q.reject('gift_cards.balance_zero');
                    }
                } else if (result.Status === 'Invalid') {
                    return _this5.$q.reject('gift_cards.invalid');
                } else if (result.Status === 'Error') {
                    return _this5.$q.reject('gift_cards.error');
                } else {
                    return ''; // Should not happen.
                }
            });

            promise.giftCardNumber = giftCardNumber;

            promise.finally(function () {
                _this5.loadingGiftCard = false;
                // console.log(giftCardNumber, 'Finished.');
            });

            return promise;
        }
    }, {
        key: 'onCodeChange',
        value: function onCodeChange() {
            if (this.loadingGiftCard) return;
            this.promise = undefined; // Clear old message for previous code.
        }
    }]);

    return WinresGiftCardsController;
}();

WinresGiftCardsController.$inject = ['$scope', '$q', 'discountService', 'cancelService'];

_module3.default.component('winresGiftCards', {
    template: require('./winresGiftCards.html'),
    controller: WinresGiftCardsController,
    bindings: {
        context: '<',
        onStateChange: '&',
        showLegend: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresGiftCards/winresGiftCards.js
// module id = 530
// module chunks = 2